import { render, staticRenderFns } from "./hsnp_wizard_step_02_margin_exact.vue?vue&type=template&id=ccf2313a&scoped=true"
import script from "./hsnp_wizard_step_02_margin_exact.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_margin_exact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf2313a",
  null
  
)

export default component.exports